import i18n from "config/i18next";

i18n.addResources("es", "filesContainer", {
  files: "Archivos",
  delete: "¿Querés eliminar el archivo?",
  replace: "¿Querés reemplazar el archivo?",
  formatError:
    "El formato del archivo es incorrecto. Subí un archivo JPG, PNG o PDF de hasta 5 mb.",
  sizeError:
    "El archivo es muy pesado. Subí un archivo JPG, PNG o PDF de hasta 5 mb.",
  loadError: "Hubo un error del navegador. Inténtalo nuevamente",
  serverError:
    "Hubo un error de conexión con el servidor. El nuevo archivo no se subió correctamente.",
});
